import { EventRoot } from './EventRoot';

export default EventRoot;
